export default {
    registerCookie: { 
        url: 'sanctum/csrf-cookie', 
        method: 'get', 
        baseURL: process.env.VUE_APP_AUTH_URL,
    },
    sendPromoCode: {
        url: 'auth/send/promoCode',
        method: 'post'
    },
    getMailingFirstName: {
        url: 'mailings/firstname',
        method: 'post'
    },
    getContacts: { 
        url: 'auth/contacts', 
        method: 'post', 
    },
    insertDebtor: {
        url: 'auth/insert',
        method: 'post'
    },
    login: { 
        url: 'auth/sanctum/token', 
        method: 'post',  
    },
    mailinglogin: { 
        url: 'mailings/token', 
        method: 'post',  
    },
    getUser: { 
        url: 'user/auth', 
        method: 'get', 
    },
    logContato: { 
        url: 'log-contato', 
        method: 'post', 
    },
    whatsText: { 
        url: 'whatsMessage', 
        method: 'post', 
    },
    sendLogWhatsappWithoutToken: { 
        url: 'sendLogWhatsappWithoutToken', 
        method: 'post', 
    },
    getLinkAccess: {
        url: '/getLinkAccess',
        method: 'post',
    }
}